import { useEffect, useState } from "react";

import {
  getAttachmentCost,
  getCost,
  getFinalCost,
  getPannelList,
} from "../../util/cost";
import { useOptionContext } from "../../context/OptionContext";
import { Attachment, FinalCost, Province } from "../../types/canvasTypes";
import ClientForm from "../ClientForm";
import QuotationTable from "../QuotationTable";
import { t } from "i18next";
import { useCurrentUser } from "../../context/UserContext";

const StepThree = () => {
  const [globalCheckbox, setCheckBox] = useState(true);
  const [finalCost, setFinalCost] = useState<FinalCost[]>([]);
  const [totalCost, setTotalCost] = useState(0);
  const [material, setMaterial] = useState<Attachment[]>([]);
  const { currentUser } = useCurrentUser();

  const { materialType, height, scale, lines, province, chalkLine, gapSize } =
    useOptionContext();

  useEffect(() => {
    const pannels = getCost(lines, {
      glassList: getPannelList(height),
      scale,
      isChalkLine: chalkLine,
      gapSize,
    });
    const material = getAttachmentCost(lines);

    const { finalCost, attachment, totalCost } = getFinalCost(
      pannels,
      materialType,
      material,
      globalCheckbox,
      lines.filter((line) => line.numberOfDoors > 1).length > 0,
      province
    );

    if (finalCost) {
      setFinalCost(finalCost);
      setMaterial(attachment);
      setTotalCost(totalCost);
    }
  }, [materialType, height, scale, lines, globalCheckbox]);

  return (
    <div className="step-container">
      <h1>
        {province === Province.Ontario ? "Third step" : "Troisieme étape"}
      </h1>
      {province === Province.Quebec && (
        <div
          style={{
            padding: "20px",
            fontFamily: "Arial, sans-serif",
            lineHeight: "1.6",
          }}
        >
          <h2>Instructions :</h2>
          <p>
            Veuillez <strong>remplir le formulaire ci-dessous</strong>, puis
            cliquez sur <strong> Sauvegarder</strong> pour enregistrer vos
            informations.
          </p>
          <p>
            Si vous ne souhaitez pas d'attaches (seulement du verre), cliquez
            sur
            <strong> attaches non inclus</strong>.
          </p>
        </div>
      )}
      <div id="sidesInformation" style={{ width: "100%" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            gap: "10px",
            alignItems: "center",
          }}
        >
          <h3>{province === Province.Ontario ? "Details" : "Détails"}</h3>
          <button
            id="myCheckbox"
            name="myCheckbox"
            className={`checkbox-button ${globalCheckbox ? "" : "blue"}`}
            onClick={() => setCheckBox((globalCheckbox) => !globalCheckbox)}
          >
            {globalCheckbox ? t("removeConnectors") : t("includeConnectors")}
          </button>
        </div>
        {currentUser && (
          <QuotationTable
            province={province}
            selectedLength={height}
            finalCost={finalCost}
            materialOption={materialType}
            material={material}
            totalCost={totalCost}
          />
        )}
        <ClientForm
          lines={lines}
          material={materialType}
          selectedLength={`${height}`}
          scale={scale}
          includeAttachement={globalCheckbox}
        />
      </div>
    </div>
  );
};
export default StepThree;
